import { Grid } from '@mui/material';
import { FC, ReactNode } from 'react';
import { useTranslate } from 'react-admin';

interface Props {
  content: ReactNode;
}

export const B2bInvestorProfileSicavGridContainer: FC<Props> = (props) => {
  const { content } = props;
  const translate = useTranslate();

  return (
    <Grid container rowSpacing={2}>
      <Grid item container>
        <Grid item xs={4}>
          <span style={{ fontWeight: 'bold' }}>
            {translate(
              'resources.bo_common.b2b.investor_profile.create.sicav_grid_configuration.retirement_year',
            )}
          </span>
        </Grid>
        <Grid item xs={8}>
          <span style={{ fontWeight: 'bold' }}>
            {translate(
              'resources.bo_common.b2b.investor_profile.create.sicav_grid_configuration.placement_support',
            )}
          </span>
        </Grid>
      </Grid>
      {content}
    </Grid>
  );
};
